/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SpleenConsistencyAssessment {
    SOFT = 'soft',
    ELASTIC = 'elastic',
    HARD = 'hard',
}
